import React from "react";
import styled from "styled-components";

const Primary = styled.h3`
  color: red;
  text-align: center;
  max-width: 350px;
  margin-left: 20px;

  display: flex;
  flex-flow: column nowrap;
`;

class emailError extends React.Component {
  render() {
    return (
      <Primary>
        Error, password does not meet minimum requirements. Please try a
        different password.
      </Primary>
    );
  }
}

export default emailError;



// WEBPACK FOOTER //
// ./src/components/PasswordFail/index.jsx